import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_129_purchase_order: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "130",
      action: "modulev1/purchase_order",
    },
    title: "Purchase order",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "purchase_order_no",
            Name: "purchase_order_summary",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/purchase_order/<id>",
                },
                ActionType: "Edit",
                ScreenId: "130",
              },
              {
                Action: {
                  Action: "Delete",
                  Module: "purchase_order_summary",
                },
                ActionType: "Delete",
                ScreenId: "130",
              },
              {
                Action: {
                  Action: "PDF",
                  Settings: "purchase_order",
                },
                ActionType: ActionType.PDF_DOWNLOAD,
                
              },
            ],
            Form: {
              Name: "purchase_order_summary",
              TableName: "purchase_order",
              DisplayName: "purchase_order",
              View: "view_purchase_order_summary",
              Filter:
                "view_purchase_order_summary.soft_delete=0 order by view_purchase_order_summary.created_at desc",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Order No.",
                  BindValue: "purchase_order_no",
                  Json_Attribute: "purchase_order_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Vendor name",
                  BindValue: "suppliername",
                  Json_Attribute: "suppliername",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Purchase date",
                  BindValue: "purchase_date",
                  Json_Attribute: "purchase_order_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Gross amount",
                  BindValue: "txt_gross_amt",
                  Json_Attribute: "gross_amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  IsClear: false,
                },
                {
                  IncludeLabel: true,
                  Label: "VAT amount",
                  BindValue: "txt_vat_amt",
                  Json_Attribute: "vat_amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  IsClear: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Net amount",
                  BindValue: "txt_net_amt",
                  Json_Attribute: "net_amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  IsClear: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Created by",
                  BindValue: "txt_created_by",
                  Json_Attribute: "created_by",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  IsClear: false,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
